export default __webpack_public_path__ + "static/media/Game 5 the great escape.383efae6.png";